// ============================================
// 📱 APP: NVA (React App)
// 📄 FILE: src/components/home/format.ts
// 🔧 PURPOSE: Le date della Home dai giorni di Roma ("AAAA-MM-GG" di
//             HomeState), nella lingua dell'app. Il giorno si formatta a
//             mezzogiorno UTC con il fuso UTC: così "lun 21" resta lunedì 21
//             anche su un telefono a New York o a Tokyo.
// ============================================

import { intlLocale } from '../../lib/locale';

/** La data di un giorno "AAAA-MM-GG" (mezzogiorno UTC), o null se la chiave non va. */
export function dayKeyDate(key: string | null | undefined): Date | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(key || '');
  if (!m) return null;
  return new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 12));
}

/** Un giorno "AAAA-MM-GG" con le opzioni di Intl ("mercoledì 23 settembre"). */
export function formatDayKey(
  key: string | null | undefined,
  lang: string,
  options: Intl.DateTimeFormatOptions,
): string {
  const d = dayKeyDate(key);
  if (!d) return '';
  return new Intl.DateTimeFormat(intlLocale(lang), { ...options, timeZone: 'UTC' }).format(d);
}

/**
 * "lun 21 → lun 28 set": il mese solo in fondo quando è lo stesso,
 * "mer 30 set → sab 3 ott" quando cambia. Stringa vuota senza date.
 */
export function formatStayRange(checkInDay: string | null | undefined, checkOutDay: string | null | undefined, lang: string): string {
  if (!dayKeyDate(checkInDay) || !dayKeyDate(checkOutDay)) return '';
  const sameMonth = (checkInDay || '').slice(0, 7) === (checkOutDay || '').slice(0, 7);
  const from = formatDayKey(checkInDay, lang, sameMonth
    ? { weekday: 'short', day: 'numeric' }
    : { weekday: 'short', day: 'numeric', month: 'short' });
  const to = formatDayKey(checkOutDay, lang, { weekday: 'short', day: 'numeric', month: 'short' });
  return `${from} → ${to}`;
}
